<template>
  <footer
    class="p-3 bg-gray-1 text-secondary d-flex align-items-center justify-content-between"
  >
    <h6>Runners</h6>
    <span>&copy; 2021 All copyrights reserved.</span>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
